<template>
  <div>
    <button class="btn btn-xs btn-danger" type="button" title="Delete" @click="showModal">
      <i class="fa fa-trash"></i>
    </button>

    <modal :id="modalId" title="Delete Timesheet">
      <form :id="formId" :action="action" method="POST">

        <div class="text-center">
          <p v-html='"You are about to delete Timesheet \"" + name + "\"."'></p>

          <p>Are you sure you want to delete it? This action cannot be undone.</p>
        </div>

        <slot name="hidden"></slot>
        <input type="hidden" name="_method" value="DELETE">
        <input type="hidden" name="_token" :value="$csrf_token">
      </form>

      <template #footer>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Cancel
        </button>
        <button type="submit" class="btn btn-danger" :form="formId">
          <i class="fa fa-fw fa-trash"></i> Delete Timesheet
        </button>
      </template>

    </modal>
  </div>
</template>

<script>
import HasModal from "../../mixins/HasModal";

export default {

  /**
   *
   * Confirmation dialog to claim Timesheet deletion.
   *
   * Input properties:
   *
   * modal-id - custom id for modal component.
   * name     - Timesheet name.
   * action   - form action URL.
   *
   * Usage examples:
   *
   * <delete-timesheet-modal modal-id="..." name="..." action="...">
   *   <template #hidden>Something hidden</template>
   * </delete-timesheet-modal>
   */

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'deleteTimesheetModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Timesheet name.
    name: {
      type: String,
      required: true,
    },
  },

  mixins: [HasModal],

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    },

  },

}
</script>

<style scoped>
.btn-group > div > .btn {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
